module.exports = function (DatePicker) {
    var tpl = require('raw!./tpl.year.html');
    DatePicker.$html.find('.cal-box').append(tpl);
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/g_datepicker_select_year.js
 ** module id = 7
 ** module chunks = 0
 **/